import { SubscriptionSessionPackUsageHistoryDTOStatus } from "@gymflow/types";
import { Status, StatusColorType } from "apps/portal/src/components/atoms";
import { startCase, toLower } from "lodash";

type UsageItemStatusProps = {
  status: SubscriptionSessionPackUsageHistoryDTOStatus;
};

const COLOR_MAP: Record<
  SubscriptionSessionPackUsageHistoryDTOStatus,
  StatusColorType
> = {
  ATTENDED: "success",
  BOOKED: "lightblue",
  NO_SHOW: "gray",
  WAITING: "gray",
  CANCELLED: "warning",
  LATE_CANCELLED: "warning",
  CONFIRMED: "success",
};

export const UsageItemStatus = ({ status }: UsageItemStatusProps) => {
  const colors = COLOR_MAP[status];

  return <Status text={startCase(toLower(status))} statusColor={colors} />;
};
